import React, { FC } from "react";

import { ListGroupProps } from "../../types";

export const ListGroup: FC<ListGroupProps> = ({ label, list }) => {
  return (
    <div className="ams-expanded-row__block">
      <div className="ams-expanded-row__label">{label}:</div>
      <div className="ams-expanded-row__text">
        <ul className="ams-expanded-row__list">
          {list.map((item, key) => {
            return (
              <li key={key} className="ams-expanded-row__item">
                {item}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
